import { render, staticRenderFns } from "./MealCalendar.vue?vue&type=template&id=6fed979a&scoped=true"
import script from "./MealCalendar.vue?vue&type=script&lang=js"
export * from "./MealCalendar.vue?vue&type=script&lang=js"
import style0 from "./MealCalendar.vue?vue&type=style&index=0&id=6fed979a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fed979a",
  null
  
)

export default component.exports